// Static { [PascalCaseKey]: epic } map for the 18 ROUTE-SCOPED
// registry keys.
//
// Static imports (not `require()`) so Rspack resolves this map at build time
// and it stays lint-checkable against RootContainer.js's `dataLayerDependencies`
// arrays. The union of those arrays, minus `SpearPhishingAgent` (promoted to
// ALWAYS_ON_EPICS — its route-scoped reducer entry is inert, and all 15
// reads in its selectors target the static slice instead), is exactly these
// 18 keys.
import activitiesEpics from './containers/Activities/epics'
import awarenessCenterEpics from './containers/AwarenessCenter/epics'
import customizedAutoSyncEpics from './containers/CustomizedAutoSync/epics'
import dashboardEpics from './containers/Dashboard/epics'
import deepfakeEpics from './containers/Deepfake/epics'
import dmarcEpics from './containers/DMARC/epics'
import emailEncryptionEpics from './containers/EmailEncryption/epics'
import encryptionPLGEpics from './containers/EncryptionPLG/epics'
import groupSettingsEpics from './containers/GroupSettings/epics'
import investigationEpics from './containers/Investigation/epics'
import loginEpics from './containers/Login/epics'
import mailboxesEpics from './containers/Mailboxes/epics'
import partnerEpics from './containers/Partner/epics'
import redTeamEpics from './containers/RedTeam/epics'
import resolutionCenterEpics from './containers/ResolutionCenter/epics'
import resourcesEpics from './containers/Resources/epics'
import settingsEpics from './containers/Settings/epics'
import vendorProtectionEpics from './containers/VendorProtection/epics'

export const ROUTE_EPICS = {
  Login: loginEpics,
  Activities: activitiesEpics,
  Resources: resourcesEpics,
  Investigation: investigationEpics,
  Partner: partnerEpics,
  Dashboard: dashboardEpics,
  Mailboxes: mailboxesEpics,
  CustomizedAutoSync: customizedAutoSyncEpics,
  ResolutionCenter: resolutionCenterEpics,
  AwarenessCenter: awarenessCenterEpics,
  Deepfake: deepfakeEpics,
  Settings: settingsEpics,
  GroupSettings: groupSettingsEpics,
  DMARC: dmarcEpics,
  EncryptionPLG: encryptionPLGEpics,
  RedTeam: redTeamEpics,
  EmailEncryption: emailEncryptionEpics,
  VendorProtection: vendorProtectionEpics,
}
